// Piccoli elementi sovrapposti alla mappa, comuni ai tre tipi di comune.

import React, { useEffect, useState } from "react";
import { Button, IconButton } from "./ui";
import { formatDistance } from "../hooks/useMeasure";
import { BACKEND, PRIVACY_URL } from "../lib/config";
import { getJson } from "../lib/http";

// Scelta tra più zone sovrapposte nel punto cliccato.
export function ZonePicker({ picker, onClose }) {
  useEffect(() => {
    if (!picker) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [picker, onClose]);
  if (!picker) return null;
  return (
    <div className="sm-zone-picker" style={{ top: picker.y + 8, left: picker.x + 8 }}>
      <div className="sm-zone-picker-title sm-section-title">Zone sovrapposte</div>
      {picker.items.map((it, i) => (
        <button key={i} type="button" title={it.label} onClick={() => { it.onPick(); onClose(); }}>
          {it.label}
        </button>
      ))}
    </div>
  );
}

// Barra azioni in basso: misura in corso, disegno in corso o area pronta.
export function BottomBar({ measure, draw, children, idleHint }) {
  if (measure.active) {
    return (
      <div className="sm-measure">
        <span className="sm-label">Misura</span>
        <span className="sm-measure-value">{measure.count > 1 ? formatDistance(measure.total) : "clicca i punti sulla mappa"}</span>
        <Button variant="ghost" size="sm" icon="x" onClick={measure.stop}>Fine</Button>
      </div>
    );
  }
  if (draw.mode) {
    return (
      <div className="sm-measure" style={{ borderColor: "var(--border-strong)" }}>
        <span className="sm-panel-text">
          {draw.mode === "rectangle" ? "Trascina per disegnare il rettangolo" : "Clicca i vertici; chiudi sul primo punto"}
        </span>
        <Button variant="ghost" size="sm" icon="x" onClick={draw.cancel}>Annulla</Button>
      </div>
    );
  }
  if (draw.shape && children) return <div className="sm-measure" style={{ borderColor: "var(--border-strong)" }}>{children}</div>;
  if (idleHint) return <div className="sm-hint">{idleHint}</div>;
  return null;
}

// Una sola promozione, piccola e chiudibile (contenuto da backend-static/ads.json:
// chiave "promo", oppure il vecchio "footer").
const PROMO_DISMISS_KEY = "survmaps.promo.chiusa";

export function PromoCard() {
  const [promo, setPromo] = useState(null);
  const [hidden, setHidden] = useState(() => {
    try { return window.sessionStorage.getItem(PROMO_DISMISS_KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    if (hidden) return;
    getJson(`${BACKEND}/backend-static/ads.json`)
      .then((ads) => setPromo(ads.promo || ads.footer || null))
      .catch(() => {});
  }, [hidden]);

  if (hidden || !promo?.image) return null;
  const close = () => {
    setHidden(true);
    try { window.sessionStorage.setItem(PROMO_DISMISS_KEY, "1"); } catch { /* storage non disponibile */ }
  };
  return (
    <aside className="sm-promo" aria-label="Promozione">
      <a href={promo.url} target="_blank" rel="noopener noreferrer">
        <img src={`${BACKEND}${promo.image}`} alt="Promozione" onError={close} />
      </a>
      <IconButton icon="x" label="Chiudi" onClick={close} />
    </aside>
  );
}

export function FootLinks() {
  return (
    <div className="sm-foot-links">
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">Privacy</a>
      <a href="https://leafletjs.com/" target="_blank" rel="noopener noreferrer">Leaflet</a>
    </div>
  );
}
